<div class="profile-container">
  <rt-dialog-header [heading]="'app.new_company_form.title' | translate"> </rt-dialog-header>
  <rt-dialog-body layout-vertical>
    <form [formGroup]="newCompanyForm" class="profile-form">
      <rt-form-field>
        <rt-label>{{ 'app.company_form.name' | translate }} </rt-label>
        <rt-input
          variant="rounded"
          [rtFormError]="nameFieldErrors"
          type="text"
          formControlName="name"
          [placeholder]="'app.company_form.name_placeholder' | translate"
        >
        </rt-input>
      </rt-form-field>
      <rt-form-field>
        <rt-label> {{ 'app.company_form.careers_site_url' | translate }} </rt-label>
        <div layout-horizontal>
          <rt-input
            variant="rounded"
            [rtFormError]="subdomainFieldErrors"
            type="text"
            formControlName="subdomain"
            [placeholder]="'app.company_form.careers_site_url' | translate"
          >
          </rt-input>
          <rt-heading variant="subheading">.recruitee.com</rt-heading>
        </div>
      </rt-form-field>
      <rt-form-field>
        <rt-label>{{ 'app.company_form.language' | translate }} </rt-label>
        <rt-select
          [hasSearch]="false"
          [required]="true"
          [options]="languageSelectOptions"
          formControlName="language"
        >
        </rt-select>
      </rt-form-field>
      <rt-checkbox formControlName="fillWithSampleData" margin-top>
        <div layout-vertical>
          <p>
            <strong>{{ 'app.company_form.fill_sample_data_heading' | translate }}</strong>
          </p>
          <p>{{ 'app.company_form.fill_sample_data_subheading' | translate }}</p>
        </div>
      </rt-checkbox>
    </form>
    <div
      class="terms-conditions"
      [innerHTML]="
        'app.new_company_form.terms_and_privacy.description'
          | translate
            : {
                terms_url: 'app.new_company_form.terms_and_privacy.terms_link' | translate,
                privacy_url: 'app.new_company_form.terms_and_privacy.privacy_link' | translate
              }
      "
      margin-top
    ></div>
  </rt-dialog-body>
  <rt-dialog-footer>
    @if (!state.loading) {
      <rt-button (click)="cancelClick()" variant="plain">
        {{ 'app.common.cancel' | translate }}
      </rt-button>
    }
    <rt-button
      (click)="submitClick()"
      [loading]="state.loading"
      [disabled]="!state.isValid"
      variant="primary"
    >
      {{ 'app.company_form.create_company' | translate }}
    </rt-button>
  </rt-dialog-footer>
</div>
